import type { RichTextSectionProps } from "~/sections/Store/RichText"

export const RichText = ({ text }: RichTextSectionProps) => {
    return (
        <div
            dangerouslySetInnerHTML={{ __html: text }}
        />
    )
}
